/* Copyright (c) Trimble Inc. All rights reserved. */

import React, { Fragment } from 'react';
import { DataRemoverDialog, DataRemoverDialogProps } from './DataRemoverDialog';
import { ButtonProps } from '@material-ui/core';
import { useDialogProps } from 'legacy-components/dialog/Dialog';
import { DataRemoverButton } from './DataRemoverButton';

export interface DataRemoverProps
  extends Omit<DataRemoverDialogProps, 'open' | 'toggle' | 'title'>, Omit<ButtonProps, 'onClick' | 'title'> {
  tooltipText?: string;
  skipConfirmationDialog?: boolean;
  icon?: JSX.Element;
  enterButtonText?: string | JSX.Element;
  title?: string; 
  fromKebab?: boolean;
}

export const DataRemover: React.FC<DataRemoverProps> = ({
  id = 'DATA_REMOVER',
  skipConfirmationDialog = false,
  confirmationText,
  icon,
  title,
  tooltipText = 'Remove',
  enterButtonText,
  onSuccess,
  asyncActionState,
  customErrorMessage,
  fromKebab,
  placeholder,
  ...props
}) => {
  const { open, toggle } = useDialogProps();


  return (
    <Fragment>
      <DataRemoverButton
        tooltipText={tooltipText}
        id={id}
        toggle={toggle}
        skipConfirmationDialog={skipConfirmationDialog}
        enterButtonText={enterButtonText}
        icon={icon}
        onConfirm={props.onConfirm}
        title={title}
        fromKebab={fromKebab}
        variant='outlined'
        className='data-remover-button'
        {...props}
      />
      {!!DataRemoverDialog && (
        <DataRemoverDialog
          title={title}
          open={open}
          toggle={toggle}
          id={id}
          onSuccess={onSuccess}
          asyncActionState={asyncActionState}
          confirmationText={confirmationText}
          customErrorMessage={customErrorMessage}
          placeholder={placeholder}
          {...props}
        />
      )}
    </Fragment>
  );
};

export default DataRemover;
